import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  useApproveCreditRequestMutation,
  useDenyCreditRequestMutation,
  useLazyGetAllCreditRequestsQuery,
  useLazyGetAllFilteredCreditRequestsQuery,
} from "../../../../store/admin/creditRequests";
import { formatDate, formatTime } from "../../../../utilities/utils";
import Button from "../../../button";
import AdminCreditSlideOver from "../slideovers/AdminCreditSlideOver";
import Pagination from "../../pagination";
import { Link } from "react-router-dom";
import SkeletonCard from "../../../commons/Skeleton/SkeletonCard";

const NewCreditRequest = ({ creditRequestDataCard, getUpdateData, meta }) => {
  const [showApproveCreditSlideOver, setShowApproveCreditSlideOver] =
    useState(false);
  const [showDenyCreditSlideOver, setShowDenyCreditSlideOver] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [selectedCreditRequestId, setSelectedCreditRequestId] = useState();
  const [creditRequestData, setCreditRequestData] = useState();

  useEffect(() => {
    if (creditRequestDataCard) {
      setCreditRequestData(creditRequestDataCard);
    }
  }, [creditRequestDataCard]);

  const [
    approveCreditRequest,
    {
      isSuccess: approveCreditRequestSuccess,
      isLoading: approveCreditRequestLoader,
      isError: approveCreditRequestError,
      data: fetchApproveData,
    },
  ] = useApproveCreditRequestMutation();

  const [
    denyCreditRequest,
    {
      isSuccess: denyCreditRequestSuccess,
      isLoading: denyCreditRequestLoader,
      data: fetchDenyData,
    },
  ] = useDenyCreditRequestMutation();

  const handleClose = () => {
    setShowApproveCreditSlideOver(false);
    setShowDenyCreditSlideOver(false);
  };

  useEffect(() => {
    if (approveCreditRequestSuccess && !approveCreditRequestLoader) {
      toast(fetchApproveData[0]);
      setShowApproveCreditSlideOver(false);
    }
  }, [approveCreditRequestSuccess]);

  useEffect(() => {
    if (denyCreditRequestSuccess && !denyCreditRequestLoader) {
      toast(fetchDenyData[0]);
      setShowDenyCreditSlideOver(false);
    }
  }, [denyCreditRequestSuccess]);

  useEffect(() => {
    // Filter requests based on status
    const pending =
      creditRequestData &&
      creditRequestData?.filter((request) => request.status === "Pending");

    // Set state variables with filtered results
    setPendingRequests(pending);
  }, [creditRequestData]);

  const handleApproveDeny = (value, type) => {
    const params = {
      decision: value,
    };
    if (type === "Approve") {
      approveCreditRequest({ selectedCreditRequestId, ...params });
    } else if (type === "Deny") {
      denyCreditRequest({ selectedCreditRequestId, ...params });
    }
  };

  // const { meta } = creditRequestDataCard ?? {};
  const { current_page, last_page, per_page } = meta ?? {};

  return (
    <>
      {!creditRequestData ? (
        <div className="grid grid-cols-1 md:grid-cols-2 3xl:grid-cols-3 4xl:grid-cols-4 gap-6">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 3xl:grid-cols-3 4xl:grid-cols-4 gap-6">
            {pendingRequests &&
              pendingRequests.map((creditData, index) => (
                <div
                  className="bg-white border border-[#EBEFF3] rounded-md p-5"
                  key={index}
                >
                  <div className="flex items-center justify-between pb-5 mb-[14px] border-b border-[#EBEFF3]">
                    <span className="bg-[#D834A0] h-[27px] px-[10px] text-xs font-bold leading-[160%] text-white inline-flex items-center justify-center rounded-md">
                      {creditData.status}
                    </span>
                    <div className="flex items-center gap-1">
                      <span className="text-xs font-normal leading-[140%] text-[#485868] hidden sm:block">
                        Requested:
                      </span>
                      <span className="text-xs font-normal leading-[140%] text-[#485868]">
                        {formatDate(creditData.created_at)}
                      </span>
                      <span className="text-[#485868] leading-[140%] -mt-1">
                        &#8226;
                      </span>
                      <span className="text-xs font-normal leading-[140%] text-[#485868]">
                        {formatTime(creditData.created_at)}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className="pb-[14px] mb-[14px] border-b border-[#EBEFF3]">
                      <h6 className="text-base font-bold leading-[160%] text-customGray mb-1 capitalize">
                        Incorrect Contact
                      </h6>
                      <div className="flex items-center gap-[10px] mb-[14px]">
                        <Link
                          to={`/admin-dashboard/matches/${creditData?.reviewedMatch?.id}`}
                          state={{ matchInfo: creditData?.reviewedMatch }}
                          className="contents"
                        >
                          <span className="text-sm font-medium leading-[140%] text-primary">
                            {creditData.reviewedMatch.lead?.first_name}{" "}
                            {creditData.reviewedMatch.lead?.last_name}
                          </span>
                        </Link>
                        <span className="text-[#485868] leading-[140%]">
                          &#8226;
                        </span>
                        <span className="text-sm font-normal leading-[140%] text-[#485868]">
                          {creditData.reviewedMatch?.lead?.email}
                        </span>
                      </div>
                      <div className="flex items-center justify-between gap-5 w-full">
                        <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block">
                          Requested By:
                          <br />
                          <strong className="text-primary font-medium">
                          <Link
                            to={`/admin-dashboard/users/${creditData?.requester?.id}`}
                            state={{ userInfo: creditData?.requester }}
                            className="contents"
                          >
                            {creditData.requester?.first_name}{" "}
                            {creditData.requester?.last_name}
                          </Link>
                          </strong>
                        </span>
                        <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block">
                          Lead ID:
                          <br />
                          <strong className="text-customGray">
                            {creditData.reviewedMatch?.lead?.id}
                          </strong>
                        </span>
                      </div>
                    </div>
                    <div className="pb-[14px] mb-[14px] border-b border-[#EBEFF3]">
                      <span className="text-sm font-bold leading-[160%] text-[#485868] inline-block mb-1">
                        Comment:
                      </span>
                      <p className="text-sm font-normal leading-[160%] text-[#485868]">
                        {creditData?.reason}
                      </p>
                    </div>
                    <div className="mb-4">
                      <div className="flex items-center justify-between gap-2 mb-[10px]">
                        <h6 className="text-base font-bold leading-[160%] text-customGray">
                          Credit Request:
                        </h6>
                        <h6 className="text-base font-bold leading-[160%] text-customGray mb-1">
                          {creditData?.credit_cost ?? 0} Credits
                        </h6>
                      </div>
                      {/* <p className="text-sm font-normal leading-[140%] text-customGray">
                        Respond By Date:{" "}
                        {formatDate(creditData.final_decision_at)}
                      </p> */}
                    </div>
                    <div className="grid grid-cols-2 gap-6">
                      <Button
                        title="approve"
                        classes="text-sm font-black leading-[160%] text-white h-10 rounded-[10px] flex items-center justify-center bg-[#16CA7C] border border-[#16CA7C] uppercase"
                        onClick={() => {
                          setSelectedCreditRequestId(creditData?.id);
                          setShowApproveCreditSlideOver(true);
                        }}
                      />
                      <Button
                        title="deny"
                        classes="text-sm font-black leading-[160%] text-[#EF2121] h-10 rounded-[10px] flex items-center justify-center bg-white border border-[#EF2121] uppercase"
                        onClick={() => {
                          setSelectedCreditRequestId(creditData?.id);
                          setShowDenyCreditSlideOver(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
          </div>
          {pendingRequests?.length < 1 && (
            <div className="border border-solid border-[#EBEFF3] rounded-md p-5 block bg-[#ffffff]">
              <div className="flex items-center justify-center my-4 text-lg text-primary font-bold">
                You don’t have any Pending credit requests.
              </div>
            </div>
          )}
        </>
      )}
      {creditRequestDataCard?.length > 0 && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
          meta={meta}
        />
      )}
      <AdminCreditSlideOver
        show={showApproveCreditSlideOver}
        setShowSlide={setShowApproveCreditSlideOver}
        handleClose={handleClose}
        handleApproveDeny={handleApproveDeny}
        type="Approve"
        loader={approveCreditRequestLoader}
      />
      <AdminCreditSlideOver
        show={showDenyCreditSlideOver}
        setShowSlide={setShowDenyCreditSlideOver}
        handleClose={handleClose}
        handleApproveDeny={handleApproveDeny}
        type="Deny"
        loader={denyCreditRequestLoader}
      />
    </>
  );
};

export default NewCreditRequest;
